<template>
  <div class="mx-sm-1 mt-9">
    <div class="page-header">
      <h1 class="page-title fw-bold">Gestion des utilisateurs Keycloak</h1>
      <div>
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link :to="{ name: 'dashboard' }">Tableau de bord</router-link>
          </li>
          <li class="breadcrumb-item active" aria-current="page">
            <router-link :to="{ name: 'classeurs' }">Gestion des utilisateurs Keycloak</router-link>
          </li>
        </ol>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <div class="card">
          <div class="card-header d-flex justify-content-between align-items-center">
            <div class="card-options">
              <div class="btn-group">
                <div class="d-flex gap-2">
                  <button
                      class="btn btn-primary btn-sm"
                      @click="showCreateModal()"
                  >
                    <i class="fe fe-plus-circle me-1"></i>
                   Ajouter
                  </button>

                </div>
              </div>
            </div>
          </div>
          <div class="card-body">


            <div class="table-responsive">
              <table class="table table-hover table-bordered text-nowrap mb-0">
                <thead class="border-top success02">
                <tr>
                  <th>#</th>
                  <th>Nom</th>
                  <th>Email</th>
                  <th>Nom d’utilisateur</th>
                  <th>Statut</th>
                  <th>Actions</th>
                </tr>
                </thead>
                <tbody v-if="paginatedUsers.length > 0" id="myTable1">
                <tr v-for="(user, index) in paginatedUsers" :key="user.id">
                  <td>{{ (currentPage - 1) * itemsPerPage + index + 1 }}</td>
                  <td>{{ user.firstName }} {{ user.lastName }}</td>
                  <td>{{ user.email }}</td>
                  <td>{{ user.username }}</td>
                  <td>
<span :class="user.enabled ? 'text-success' : 'text-danger'">
                  {{ user.enabled ? 'Actif' : 'Désactivé' }}
</span>
                  </td>
                  <td>
                    <button class="btn btn-sm btn-warning me-1" @click="showCreateModal(user)">
                      <i class="fe fe-edit"></i>
                    </button>
                    <button class="btn btn-sm btn-danger me-1" @click="deleteUser(user.id)">
                      <i class="fe fe-trash"></i>
                    </button>
                    <button class="btn btn-sm"
                            :class="user.enabled ? 'btn-secondary' : 'btn-success'"
                            @click="toggleUserEnabled(user)">
                      {{ user.enabled ? 'Désactiver' : 'Activer' }}
                    </button>
                  </td>
                </tr>
                </tbody>
                <tbody v-else>
                <tr class="primary02">
                  <td colspan="6" class="text-center">Aucun utilisateur trouvé.</td>
                </tr>
                </tbody>
              </table>
            </div>
            <div v-if="users.length > 0" class="mt-3 d-flex justify-content-between align-items-center">
              <button class="btn btn-sm btn-primary" @click="currentPage--" :disabled="currentPage === 1">Précédent</button>
              <span>Page {{ currentPage }} / {{ totalPages }}</span>
              <button class="btn btn-sm btn-primary" @click="currentPage++" :disabled="currentPage === totalPages">Suivant</button>
            </div>
          </div>
        </div>
      </div>
    </div>


    <!-- Modal -->
    <div class="modal fade"  id="modal-upload-form" tabindex="-1" role="dialog" style="background-color: rgba(0, 0, 0, 0.5);">
      <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header bg-primary text-white">
            <h6 class="modal-title fw-bold">Créer un utilisateur</h6>
            <button aria-label="Close" class="btn-close text-white" data-bs-dismiss="modal"
                    type="button"><span aria-hidden="true">×</span></button>
          </div>

          <div class="modal-body">
            <GenericForm :value="payload" :isEditing="isEditing" @submit="handleSubmit" @cancel="onCancel">
              <template v-slot="{ formData, isEditing }">
                <div class="form-row">
                  <div class="form-group col-md-6 mb-2">
                    <InputField
                        label="Nom d’utilisateur"
                        :value="formData.username"
                        :rules="'required'"
                        :required="true"
                        :disabled="isEditing"
                        placeholder="Nom d’utilisateur"
                        @input="formData.username = $event"
                    />
                  </div>

                  <div class="form-group col-md-6 mb-2">
                    <InputField
                        label="Email"
                        :value="formData.email"
                        :rules="'required|email'"
                        :required="true"
                        placeholder="Adresse email"
                        @input="formData.email = $event"
                    />
                  </div>
                </div>

                <div class="form-row">
                  <div class="form-group col-md-6 mb-2">
                    <TextareaField
                        label="Biographie"
                        :value="formData.bio"
                        :rules="'required'"
                        :required="true"
                        placeholder="Écrivez une courte biographie..."
                        @input="formData.bio = $event"
                    />
                  </div>

                  <div class="form-group col-md-6 mb-2">
                    <SelectField
                        label="Pays"
                        :value="formData.country"
                        :rules="'required'"
                        :required="true"
                        :options="countryOptions"
                        labelKey="label"
                        trackKey="code"
                        placeholder="Sélectionnez un pays"
                        @input="formData.country = $event"
                    />
                  </div>
                </div>
              </template>
            </GenericForm>
            <ValidationObserver ref="observer" v-slot="{ invalid }">
              <form @submit.prevent="handleFormSubmit">
                <div class="form-row">
                  <div class="form-group col-md-6 mb-2">
                    <ValidationProvider name="Nom d’utilisateur" rules="required" v-slot="{ errors }">
                      <label class="form-label">Nom d’utilisateur <span class="text-danger">*</span></label>
                      <input type="text" class="form-control" :disabled="isEditing" v-model="payload.username" placeholder="Nom d’utilisateur" />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </ValidationProvider>
                  </div>
                  <div class="form-group col-md-6 mb-2">
                    <ValidationProvider name="Email" rules="required" v-slot="{ errors }">
                      <label class="form-label">Email</label>
                      <input type="text" class="form-control" v-model="payload.email" placeholder="Email" />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </ValidationProvider>
                  </div>
                </div>

                <div class="form-row">

                  <div class="form-group col-md-6 mb-2">
                    <ValidationProvider name="Prénom" rules="required" v-slot="{ errors }">
                      <label for="Prénom" class="form-label">Prénom <span class="text-danger">*</span></label>
                      <input type="text" class="form-control" v-model="payload.firstName" placeholder="Prénom" />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </ValidationProvider>
                  </div>

                  <div class="form-group col-md-6 mb-2">
                    <ValidationProvider name="Nom" rules="required" v-slot="{ errors }">
                      <label for="Nom" class="form-label">Nom <span class="text-danger">*</span></label>
                      <input type="text" class="form-control" v-model="payload.lastName" placeholder="Nom" />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </ValidationProvider>
                  </div>

                </div>
                <div class="form-row">
                  <div class="form-group col-md-6 mb-2">
                    <ValidationProvider
                        name="Téléphone"
                        rules="required"
                        v-slot="{ errors }"
                    >
                      <label class="form-label">Numéro de téléphone <span class="text-danger">*</span></label>
                      <input type="text" class="form-control" v-model="payload.phoneNumber" placeholder="Ex: +22900000000" />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </ValidationProvider>
                  </div>

                  <div class="form-group col-md-6 mb-2">
                    <ValidationProvider name="Pays" rules="required" v-slot="{ errors }">
                      <label class="form-label">Pays <span class="text-danger">*</span></label>
                      <GenericSelect
                          v-model="payload.country"
                          :options="countryOptions"
                          label-key="label"
                          track-key="code"
                          placeholder="Sélectionnez un pays"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="form-group text-end mt-3">
                  <button class="btn btn-gray me-2" type="button" data-bs-dismiss="modal" >Annuler</button>
                  <button class="btn btn-success" type="submit" :disabled="invalid">
                    <span class="fe" :class="isEditing ? 'fe-edit' : 'fe-check'"></span>
                    {{ isEditing ? 'Modifier' : 'Enregistrer' }}
                  </button>
                </div>
              </form>
            </ValidationObserver>
          </div>


      </div>
    </div>
    </div>

  </div>
</template>
<script>

  import GenericSelect from "../../../components/GenericSelect.vue";
  import SelectField from "../../../components/forms/SelectField.vue";
  import TextareaField from "../../../components/forms/TextareaField.vue";
  import InputField from "../../../components/forms/InputField.vue";
  import GenericForm from "../../../components/forms/GenericForm.vue";

  export default {
    name: "Users",
    components: {GenericForm, InputField, TextareaField, SelectField, GenericSelect},
    data() {
      return {
        payload: {
          id: "",
          username: "",
          email: "",
          password: "",
          firstName: "",
          phoneNumber: "",
          country: null,
          lastName: ""
        },
        users: [],
        exercices : [],
        currentPage: 1,
        itemsPerPage: 10,
        importedData: [],
        countryOptions: [
          { code: 'BJ', label: 'Bénin' },
          { code: 'FR', label: 'France' },
          { code: 'CI', label: 'Côte d\'Ivoire' },
          { code: 'CM', label: 'Cameroun' },
          { code: 'SN', label: 'Sénégal' }
        ]
      }
    },
    mounted() {
    },
    computed: {
      isEditing() {
        return this.payload.id !== null && this.payload.id !== undefined && this.payload.id !== '';
      },
      paginatedUsers() {
        const start = (this.currentPage - 1) * this.itemsPerPage;
        return this.users.slice(start, start + this.itemsPerPage);
      },
      totalPages() {
        return Math.ceil(this.users.length / this.itemsPerPage);
      },
    },
    methods : {
      handleSubmit(data) {
        console.log("Soumis avec :", data);
      },
      onCancel() {
        console.log("Annulé");
      },
      showCreateModal(user = null){
        if (user) {
          this.payload = { ...user };  // copie pour éviter modification directe
        } else {
          // Initialise payload avec ses propriétés vides (valeurs par défaut)
          this.payload = {
            id: "",
            username: "",
            email: "",
            password: "",
            firstName: "",
            lastName: "",
            phoneNumber: "",
            country: null
          };
        }
        $('#modal-upload-form').modal('show');
      },
      async handleFormSubmit() {
        try {
          if(this.isEditing) {
            // Edition utilisateur
            await this.$http.put(`/admin/keycloak/users/${this.payload.id}`, this.payload);
            this.$toast.success("Utilisateur modifié avec succès");
          } else {
            // Création utilisateur
            await this.$http.post('/admin/keycloak/users', this.payload);
            this.$toast.success("Utilisateur créé avec succès");
          }
          this.fetchUsers(); // Recharger la liste
          $('#modal-upload-form').modal('hide');
        } catch (error) {
          this.$toast.error("Erreur lors de l'enregistrement : " + error.response.data.message);
        }
      },
      async deleteUser(userId) {
        if(!confirm("Confirmez-vous la suppression de cet utilisateur ?")) return;
        try {
          await this.$http.delete(`/admin/keycloak/users/${userId}`);
          this.$toast.success("Utilisateur supprimé");
          this.fetchUsers();
        } catch (e) {
          this.$toast.error("Erreur lors de la suppression");
        }
      },

      async toggleUserEnabled(user) {
        try {
          if(user.enabled) {
            await this.$http.post(`/admin/keycloak/users/${user.id}/disable`);
          } else {
            // S'il y a un endpoint pour réactiver, par exemple:
            await this.$http.post(`/admin/keycloak/users/${user.id}/enable`);
          }
          this.fetchUsers();
        } catch (e) {
          this.$toast.error("Erreur lors de la modification du statut");
        }
      },

       fetchUsers() {
        this.$loading(true);
        this.$http.get("/admin/keycloak/users")
            .then(({ data }) => {
              console.log(data);
          this.users = data;
              this.$loading(false);
            });

      },

      getExercices() {
        this.$loading(true);
        this.$http.get('/exercice')
            .then(({data}) => {
              console.log(data);
              console.log(1);
              this.exercices = data;
              this.$loading(false);

            });
      },
    },
    created() {

       // this.fetchUsers()


    },
  }
</script>


<style scoped>

</style>